// Guidance copy for Reg M PreClear and History: one file so compliance wording changes are a one-file edit.
// Never add keys for the attestation text or its checkbox label; compliance owns that wording elsewhere.
const HELP = {
  security:
    "Type 2 or more characters to match every security that starts with them, for example CRG finds CRGY US; 1 character is matched exactly. Suggestions appear after 3 characters. Choose a suggestion to check that security (and listings sharing its ISIN) instead of a prefix. Press Enter to check.",
  pricingDate:
    "The date the offering is priced. The restricted window is the five NYSE trading days ending on this date (the last trading day on or before it).",
  filingDate:
    "Optional. The date the registration statement was first filed. If it falls inside the five-day window, the window starts on this date. Leave empty if unsure: the full five days are checked.",
  window:
    "Five NYSE trading days ending on the pricing date. If the pricing date is not a trading day, the window ends on the last trading day before it. A later filing date shortens the window.",
  matchMode:
    "Prefix search checks every security that starts with your text. Exact match starts from the security you chose; the tool still includes other listings that share its ISIN and any related instruments.",
  resolvedSymbols:
    "Every security the tool matched to your text, including other listings that share an ISIN. Sales of these can flag the check; options, convertibles and swaps in the list are informational only.",
  shortSales:
    "Short, Sell Short, SS or Short Sell trades of the security in the window, across all strategies and brokers.",
  longSales:
    "Sell, Sell Long or Long Sell trades in the window. Any sale is flagged, even when the fund is net long.",
  netPosition:
    "Latest net quantity across matched symbols. Includes option and convertible position quantities; only swaps are excluded. Shown for context. A net short position does not flag the check by itself.",
  netShortToday:
    "True when the total or any single matched symbol is net short today. Includes option and convertible position quantities; only swaps are excluded.",
  unresolved:
    "True when nothing in the dashboard data matched your text, so no trades could be checked. Confirm the identifier.",
  relatedInstruments:
    "Options, convertibles and swaps linked to the security. Informational: they never flag the check by themselves.",
  positions:
    "Latest positions for the matched symbols. Swap rows are listed but not counted in the net position.",
  historyStatus:
    "Flagged means the check found a short sale or a sale of a long position in the window. The original result never changes after attestation.",
  historyReview:
    "Pending review: flagged and waiting for compliance. Cleared: compliance reviewed it and cleared it. Not applicable: the check was not flagged.",
  prefixSearch: "This check searched every security starting with the typed text.",
  verify:
    "Checks the stored signature, the record chain and any compliance reviews.",
  reviewAction:
    "Clear records that compliance reviewed this flagged check and cleared it. Reopen withdraws an earlier clearance. A note is required.",
  moreFilters: "Filter by short sales, sales of long positions, net short today, or unresolved security.",
};

// Marker key (as in regmFormat MARKERS) to its tooltip.
export const MARKER_HELP = {
  has_short_sales: HELP.shortSales,
  has_long_sales: HELP.longSales,
  net_short_today: HELP.netShortToday,
  unresolved_security: HELP.unresolved,
};

// History column key (as in HISTORY_FIELDS) to its header tooltip.
export const FIELD_HELP = {
  window: HELP.window,
  status: HELP.historyStatus,
  review: HELP.historyReview,
};

export default HELP;
